import React from "react";

import styled from "styled-components";

const StyledImg = styled.img`
  max-height: 350px;
`;
function FeedItem(props) {
  const { feedItem } = props;

  const { id, caption, media_type: mediaType, media_url: mediaUrl } = feedItem;

  if (mediaType !== "IMAGE") {
    return null;
  }

  return (
    <StyledImg alt={caption} className="img-fluid" id={id} src={mediaUrl} />
  );
}

export default FeedItem;
